import { logger } from "src/app/modules/logging/logger.reference";
import {
  PadlockTokenActions,
  PadlockTokenActionTypes,
} from "./padlock-token.actions";

export const padlockTokenFeatureKey = "padlockToken";

export interface PadlockTokenState {
  pending: boolean;
  token: string;
  credentialError?: boolean;
}

export const initialPadlockTokenState: PadlockTokenState = {
  pending: false,
  token: null,
  credentialError: false,
};

export function padlockReducer(
  state = initialPadlockTokenState,
  action: PadlockTokenActions,
): PadlockTokenState {
  switch (action.type) {
    case PadlockTokenActionTypes.GetPadlockToken:
      logger.debug(`STORE: ${padlockTokenFeatureKey}.pending`, true);
      return Object.assign({}, state, {
        pending: true,
        credentialError: false,
      });

    case PadlockTokenActionTypes.GetPadlockTokenSuccess:
      logger.debug(`STORE: ${padlockTokenFeatureKey} success`);
      return Object.assign(
        {},
        state,
        action.source === "b2c"
          ? { token: action.token }
          : { pending: false, credentialError: false, token: action.token },
      );

    case PadlockTokenActionTypes.GetPadlockTokenFailure:
      logger.debug(`STORE: ${padlockTokenFeatureKey} failure`);
      return action.source === "b2c"
        ? state
        : Object.assign({}, state, { pending: false, credentialError: true });

    default:
      return state;
  }
}
